
import { default as axios } from 'axios';
import { Component, Vue } from 'vue-property-decorator';
import { State } from 'vuex-class';
import Question from '../../components/questionnaires/Question.vue';
import Rotation from '../../components/rotation/Rotation.vue';
import CoachesAndTribeInfo, { ICoachesAndTribeTooltips } from '../../components/shared/CoachesAndTribeInfo.vue';
import JoeyLoading from '../../components/shared/JoeyLoading.vue';
import { ConsultantBarometerQuestionPhrases } from '../../shared/configuration/BarometerConfig';
import { IAccountHyperMediaRepresentation } from '../../shared/contracts/AccountContract';
import { AnswerType, Point } from '../../shared/contracts/AnswerContract';
import { IPersonMetadataHypermediaRepresentation } from '../../shared/contracts/PersonContract';
import { INewSnapshotRepresentation } from '../../shared/contracts/SnapshotContract';
import { eventService } from '../../shared/services/EventService';
import { logService } from '../../shared/services/LogService';
import { urlService } from '../../shared/services/UrlService';
import { utilService } from '../../shared/services/UtilService';
import { IUserState } from '../../store/contract';
import store from '../../store/store';
import { NewAnswerModel } from './QuestionnaireModel';
import TransparancyInfo from '@/components/shared/TransparancyInfo.vue';

@Component({
    components: {
        Question,
        JoeyLoading,
        CoachesAndTribeInfo,
        TransparancyInfo,
        Rotation,
    },
})
export default class ConsultantQuestionnaire extends Vue {
    @State('user') userState: IUserState;
    private overallComment: string = '';
    private answers: NewAnswerModel[] = [];
    private answerTypeEnum = AnswerType;
    private questionnaireForm: any = {};
    private isSubmitting = false;
    private loadingAccounts = false;
    private questionPhrases = ConsultantBarometerQuestionPhrases;

    private personMetadata: IPersonMetadataHypermediaRepresentation = null;

    coachesAndTribeTooltips: ICoachesAndTribeTooltips = {
        emFullNameTooltip: 'You do not have an EM yet.',
        ltCoachFullNameTooltip: 'You do not have a LT Coach yet.',
        tribeNameTooltip: 'You are not in a Tribe yet.',
        firestaerterTooltip: 'You do not have a Firestaerter yet'
    };

    created() {
        let prefilledAnswer = this.$route.params.prefilledAnswer as Point;
        this.answers = [
            this.createNewAnswer(AnswerType.Project, prefilledAnswer),
            this.createNewAnswer(AnswerType.Rotation, prefilledAnswer),
            this.createNewAnswer(AnswerType.Growth, prefilledAnswer),
            this.createNewAnswer(AnswerType.Network, prefilledAnswer),

        ];
        this.retrieveMetaData();
    }

    public onAnswerChanged(newAnswer: NewAnswerModel, index: number) {
        this.answers[index] = newAnswer;
    }

    public rotationAccountSelected(account: IAccountHyperMediaRepresentation) {}

    public isValidAccount(account: IAccountHyperMediaRepresentation) {
        return account && account.accountId;
    }

    public isValid() {
        let formValid = this.questionnaireForm.$valid;
        let accountsValid =
            this.answers.every((a) => a.answerType !== AnswerType.Project || !!a.account) &&
            this.answers.every((a) => a.answerType !== AnswerType.Rotation || !!a.account);

        return formValid && accountsValid;
    }

    public addProject() {
        this.answers.push(this.createNewAnswer(AnswerType.Project));
        this.answers.push(this.createNewAnswer(AnswerType.Rotation));
    }


    public canRemoveProject(index: number): boolean {
        return index > 0;
    }

    public canRemoveRotation(index: number): boolean {
        return index > 3;
    }
    public removeProject(index: number) {
        this.answers.splice(index+1, 1);
        this.answers.splice(index, 1);
    }

    public async save() {
        if (this.isValid()) {
            this.isSubmitting = true;
            try {
                let url = store.state.root._links.update_barometer.href;
                let snapshot: INewSnapshotRepresentation = {
                    overallComment: this.overallComment,
                    answers: this.answers.map((a) => a.mapToNewAnswerRepresentation()),
                };
                await axios.post(url, snapshot);
                eventService.track('Barometer', 'Submitted');
                this.$router.push({ name: 'barometer', params: { personId: this.userState.user.id.toString() } });
            } catch (err) {
                logService.logException(err, 'Could not save barometer');
                this.$snotify.error(`Could not save your new barometer. Try again or contact ICT Support.`);
                this.isSubmitting = false;
            }
        }
    }

    public async searchAccounts(query: string, done: Function): Promise<void> {
        const url = `${store.state.root._links.search_accounts.href}?q=${encodeURIComponent(query)}`;
        const accounts = await axios.get(url);
        done(accounts.data);
    }

    public async retrieveMetaData() {
        const url = urlService.replaceURIPlaceholders(store.state.root._links.person_metadata.href, {
            personId: this.userState.user.id.toString(),
        });
        this.personMetadata = (await axios.get(url)).data;
    }

    public cancel() {
        this.$router.go(-1);
    }

    private createNewAnswer(type: AnswerType, quantitativeAnswer?: Point): NewAnswerModel {
        return new NewAnswerModel(utilService.generateGuid(), type, quantitativeAnswer);
    }
}
